export enum OtpChannelEnum {
  SMS = 'sms',
  EMAIL = 'email',
  WHATSAPP = 'whatsApp',
}
